import { Handle, Position } from "@xyflow/react";
import { BiPlay, BiPlus, BiTrash } from "react-icons/bi";
import { MdApps, MdWarning, MdWebhook } from "react-icons/md";
import { BsLightningFill } from "react-icons/bs";
import { TbClipboardCheck } from "react-icons/tb";
import { CgTimer } from "react-icons/cg";
import { param } from "framer-motion/client";

const TRIGGER_UI_MAP = {
    manual: {
        icon: BiPlay,
        text: "Runs when a user manually starts the workflow"
    },
    schedule: {
        icon: CgTimer,
        text: "Runs automatically on a recurring schedule or at a specific time"
    },
    app: {
        icon: MdApps,
        text: "Runs when an event is triggered from a connected app"
    },
    webhook: {
        icon: MdWebhook,
        text: "Runs when an external service sends a webhook request"
    },
    form: {
        icon: TbClipboardCheck,
        text: "Runs when a form is submitted by a user"
    },
    workflow_call: {
        icon: BsLightningFill,
        text: "Runs when another workflow calls this workflow"
    }
};

const TriggerNode = ({ data, setOpenOverDropdown }) => {
    const handleAdd = (e) => {
        e.stopPropagation();
        data.onAddNext?.(data.id);
    };
    const triggerType = data?.nodeType
    const ui = TRIGGER_UI_MAP[triggerType];
    const Icon = ui?.icon || BsLightningFill;

    let paramsToShow = null
    const params = data?.params

    const intervalMap = {
        minutes: "min",
        hours: "h",
        days: "D",
        weeks: "W",
        months: "M",
    };

    if (triggerType == "schedule") {
        if (params?.rules?.length === 1) {
            const { interval, value, minute, hour } = params?.rules[0];

            const short = intervalMap[interval] ?? interval;

            if (interval == "minutes" || interval == "hours") {
                paramsToShow = `${value}${short}`;
            } else {
                const pad = (n) => String(n).padStart(2, "0");
                const time = `${pad(hour)}:${pad(minute)}`;
                paramsToShow = `${value}${short} - ${time}`;
            }

        } else {
            paramsToShow = "+ Rules";
        }
    } else {
        paramsToShow = "On play";
    }

    return (
        <div className="default_node trigger_node">

            <Handle
                type="source"
                position={Position.Right}
                className="custom-handle"
            />

            <div className="custom_node_content">
                <div className="custom_node_title">
                    <i><Icon /></i>
                    <span >
                        {data?.params?.custom_name || "Trigger"}
                    </span>
                </div>
            </div>
            <span className="node_bottom_info">{paramsToShow}</span>

            <div className="node_right_plus" onClick={handleAdd}>
                <BiPlus />
            </div>

        </div>
    );
};

export default TriggerNode;